import React from 'react'
import Box from '@material-ui/core/Box'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { Label, Value } from 'components/program-marketing/registration-card'
import HelpSvg from 'images/icons/fc-marketing/help.svg'

const useStyles = makeStyles(theme => ({
  row: {
    width: '100%',
    boxShadow: 'none',
    boxSizing: 'border-box',
    cursor: 'pointer',
    fontSize: '16px',
    lineHeight: '21px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingRight: theme.spacing(2),
  },
}))

export const Cost = ({ viewAnnualMembership, coachFee, pgaFee, totalFee }) => {
  const classes = useStyles()

  return (
    <>
      <Box>
        <Label>Cost</Label>
      </Box>
      <Box className={classes.row} onClick={viewAnnualMembership} mb={2}>
        <Value>
          ${totalFee} Per Team (${coachFee} Coaching Fee + ${pgaFee} Annual
          Membership) + 3% Processing Fee*
        </Value>
        <Box display="flex" alignItems="center" mr={1}>
          <img src={HelpSvg} alt="fee-help" />
        </Box>
      </Box>
      <Box mb={2}>
        <Label>
          *Includes annual membership (one per calendar year) if applicable
        </Label>
      </Box>
    </>
  )
}
